import React, { useState } from "react";
import axios from "axios";
import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { API_URL } from "../../../config";
import Cookies from "js-cookie";

const SKUImageManager = ({ skuId, images, onImagesUpdated }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  console.log("Current images:", images);
  const USER_ID = Cookies.get("id");

  // ---- Upload new images ----
  const handleAddImages = async () => {
    if (!selectedFiles.length) return alert("Please select images first!");
    const formData = new FormData();
    selectedFiles.forEach((file) => formData.append("images", file));
    formData.append("userId", USER_ID);

    try {
      const res = await axios.post(
        `${API_URL}/addSKUImages/${skuId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      onImagesUpdated(res.data.images);
      setSelectedFiles([]);
    } catch (err) {
      console.error("Upload error:", err);
      alert("Failed to upload images.");
    }
  };

  // ---- Delete an image ----
  const handleDeleteImage = async (imageName) => {
    try {
      const res = await axios.delete(`${API_URL}/deleteSKUImage/${skuId}`, {
        data: { imageName , userId: USER_ID },
      });
      onImagesUpdated(res.data.images);
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete image.");
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
        Manage SKU Images
      </Typography>

      {/* Existing Images */}
      <Grid container spacing={1}>
        {images?.length ? (
          images.map((img, idx) => (
            <Grid item key={idx}>
              <Box
                sx={{
                  position: "relative",
                  width: 100,
                  height: 100,
                  borderRadius: 2,
                  overflow: "hidden",
                  border: "1px solid #ccc",
                }}
              >
                <img
                  src={`${API_URL}/uploads/${img.imageName}`}
                  alt=""
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => handleDeleteImage(img.imageName)}
                  sx={{
                    position: "absolute",
                    top: 2,
                    right: 2,
                    bgcolor: "white",
                    "&:hover": { bgcolor: "red", color: "white" },
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            </Grid>
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            No images uploaded.
          </Typography>
        )}
      </Grid>

      {/* Upload New Images */}
      <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 2 }}>
        <Button
          component="label"
          variant="outlined"
          startIcon={<AddPhotoAlternateIcon />}
        >
          Select Images
          <input
            hidden
            multiple
            accept="image/*"
            type="file"
            onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
          />
        </Button>

        {selectedFiles.length > 0 && (
          <Button variant="contained" color="primary" onClick={handleAddImages}>
            Upload ({selectedFiles.length})
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default SKUImageManager;
